import React from 'react';
import { useClassName, useBannerVisibility } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import { ScrollDownArrow, LogoOverlay } from './HeroOverlays';
import useCustomStyle from '../../hooks';
import HomepageAsset from 'public/screens/Home/Components/Asset';
import Actions from '../Actions';
import Link from '../Link';

import './hero.less';
import { getStylesByPrefix } from '../../utils';

export default function Hero({ component, refs }) {
  const classNames = useClassName('CLPHero');
  const isBannerVisible = useBannerVisibility();

  const [, styles] = useCustomStyle(component.fields.settings);

  const withOverlay = Boolean(
    component?.fields?.title ||
      component.fields.title ||
      component?.fields?.links?.length
  );
  const useFullScreen = styles['--full-screen-hero'];
  const showOverlayGradient = styles['--show-overlay-gradient'] === 'true';
  const hideArrow = styles['--hide-arrow-hero'];
  const logoOverlay = component?.fields?.logoOverlay;
  console.log({ styles });
  return (
    <div
      className={classNames([
        'container',
        ((withOverlay && !component?.fields?.hideLinearGradient) ||
          showOverlayGradient) &&
          'overlay',
      ])}
      style={{
        ...getStylesByPrefix('--container-', styles),
        ...(styles?.['--overlay-background'] && {
          '--overlay-background': styles['--overlay-background'],
        }),
        ...(styles?.['--overlay-mix-blend-mode'] && {
          '--overlay-mix-blend-mode': styles['--overlay-mix-blend-mode'],
        }),
        ...(styles?.['--overlay-height'] && {
          '--overlay-height': styles['--overlay-height'],
        }),
      }}>
      <HomepageAsset
        asset={component.fields.asset}
        className={classNames('media')}
        style={{
          opacity: 1,
          aspectRatio: useFullScreen ? 'unset' : undefined,
          height: useFullScreen
            ? `calc(100vh - 60px - ${isBannerVisible ? '34px' : '0px'})`
            : undefined,
          ...getStylesByPrefix('--hero-asset-', styles),
        }}
      />
      <ScrollDownArrow useFullScreen={useFullScreen && !hideArrow} />
      <LogoOverlay logo={logoOverlay} />

      {withOverlay && (
        <div
          className={classNames('content')}
          style={getStylesByPrefix('--content-', styles)}>
          {Boolean(component?.fields?.title) && (
            <h1
              style={Object.fromEntries(
                Object.entries(styles)
                  .filter(([key]) => key.startsWith('--title'))
                  .map(([key, value]) => [key.replace('--title-', ''), value])
              )}>
              {component.fields.title}
            </h1>
          )}
          {Boolean(component?.fields?.description) && (
            <h2
              style={Object.fromEntries(
                Object.entries(styles)
                  .filter(([key]) => key.startsWith('--description'))
                  .map(([key, value]) => [
                    key.replace('--description-', ''),
                    value,
                  ])
              )}>
              <ContentfulRichText
                field={{ 'en-US': component.fields.description }}
              />
            </h2>
          )}
          {Boolean(component?.fields?.links?.length) && (
            <Actions style={getStylesByPrefix('--actions-', styles)}>
              {component.fields.links.map((link) => (
                <Link key={link.sys.id} component={link} refs={refs} />
              ))}
            </Actions>
          )}
        </div>
      )}
    </div>
  );
}
